export const events = {
  eventsCardDurationText: 'duration',
  eventsSearchInputText: 'Search',
  eventsRegisteredToEventAlertTitle: 'Registered successfully',
  eventsUnregisteredToEventAlertTitle: 'Unregistered successfully',
  eventsExternalRegistrationPopupTitle: 'Register',
  eventsExternalRegistrationPopupContent: 'Have you successfully registered?',
  eventsExternalRegistrationNoButtonTitle: 'No',
  eventsExternalRegistrationYesButtonTitle: 'Yes',
  eventsCurtainCopyOptionTitle: 'Copy link',
  eventsCurtainFlagOptionTitle: 'Flag content',
  eventsLinkCopiedAlertText: 'Link copied!',
  eventsCurtainAddToCalendOptionTitle: 'Add to calendar',
  eventdetailsAgendaButtonTitle: 'Agenda',
  eventdetailsOnMapButtonTitle: 'On map',
  eventdetailsOnlineLocationTitle: 'Online',
  eventdetailAmountsRegisteredText: 'Attendees',
  eventdetailsSeeAllButtonTitle: 'See all',
  eventdetailsRegisteredButtonTitle: 'Registered',
  eventdetailsRegisterButtonTitle: 'Register',
  eventdetailsRegisteredAlertText: 'Registered successfully',
  eventdetailsUnregisteredAlertText: 'Unregistered successfully',
  eventdetailsAgendaTitle: 'Agenda',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Registered Users',
  eventdetailsSpeakersCurtainTitle: 'Speakers',
  eventdetailsSpeakersSectionTitle: 'Speakers',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'See all',
  eventdetailsCustomSectionSeeAllButtonTitle: 'See all',
  eventdetailsCurtainCopyOptionTitle: 'Copy link',
  eventdetailsCurtainFlagOptionTitle: 'Flag content',
  eventsdetailsLinkCopiedAlertText: 'Link copied!',
  eventdetailsCurtainAddToCalOptionTitle: 'Add to calendar',
  eventDetailsAddCalendarPopupTitle: 'Calendar',
  eventdetailsAddCalendarPopupContent: 'Add to Calendar?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'No',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Yes',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Copy link',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Flag content',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Link copied!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Copy link',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Flag content',
  eventsFlag: 'Flag',
  eventsJoin: 'Join',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Link copied!',
  eventContentReported: 'Content reported',
  eventsError: 'Something went wrong!',
  eventdetailsExternalRegistrationPopupContent: 'Have you successfully registered?',
  eventdetailsExternalRegistrationNoButtonTitle: 'No',
  eventdetailsExternalRegistrationYesButtonTitle: 'Yes',
  eventdetailsExternalRegistrationPopupTitle: 'Register',
  eventsCardRegisteredButtonTitle: 'Registered',
  eventsCardRegisterButtonTitle: 'Register',
  eventsJoinLink: 'Link to join: [url]{link}[/url][br]',
  eventsGuest: 'Guest',
  eventsNoSessionInDay: 'No events this day.',
  eventsShowUpcomingEvent: 'Show upcoming event'
}
